<script>import { Animator } from "../../util/animator.js";
import { onMount, afterUpdate } from "svelte";
export let name;
export let open = false;
export let orientation = "vertical";
export let size = "auto";
export let crossSize = "100%";
export let speed = 125;
const animationOptions = {
  duration: speed,
  easing: "ease-out"
};
let containerElem;
let headerSlotElem;
let indicatorElem;
let contentSlotElem;
let containerAnimator;
let indicatorAnimator;
let headerSize = 0;
onMount(() => {
  containerAnimator = new Animator(containerElem);
  indicatorAnimator = new Animator(indicatorElem);
  headerSize = headerSlotElem ? headerSlotElem.scrollHeight : 0;
  if (orientation === "horizontal" && size === "auto") {
    size = `${contentSlotElem.scrollWidth + headerSize}px`;
  }
});
afterUpdate(() => {
  headerSize = headerSlotElem ? headerSlotElem.scrollHeight : 0;
  if (orientation === "horizontal" && size === "auto") {
    size = `${contentSlotElem.scrollWidth + headerSize}px`;
  }
});
const headerClicked = (ev) => {
  containerAnimator.cancel();
  indicatorAnimator.cancel();
  let containerKeyFrame;
  let indicatorKeyFrame;
  const containerRect = containerElem.getBoundingClientRect();
  if (!open) {
    containerKeyFrame = orientation === "vertical" ? {
      height: [
        `${containerRect.height}px`,
        `${contentSlotElem.scrollHeight + headerSize}px`
      ]
    } : {
      width: [
        `${containerRect.width}px`,
        `var(--initial-size)`
      ]
    };
    indicatorKeyFrame = {
      transform: [
        "rotate(0)",
        //opening start
        "rotate(-90deg)"
        //opening end
      ]
    };
    containerElem.classList.remove("closed");
  } else {
    containerKeyFrame = orientation === "vertical" ? { height: [`${containerRect.height}px`, `${headerSize}px`] } : { width: [`${containerRect.width}px`, `${headerSize}px`] };
    indicatorKeyFrame = {
      transform: [
        "rotate(-90deg)",
        //closing start
        "rotate(0)"
        //closing end
      ]
    };
  }
  containerAnimator.animate(
    containerKeyFrame,
    animationOptions,
    () => {
      open = !open;
    }
  );
  indicatorAnimator.animate(
    indicatorKeyFrame,
    animationOptions
  );
};
</script>

<div
  bind:this={containerElem}
  class="fold-container {name} {orientation} {open ? 'open' : 'closed'}"
  style="--header-size: {headerSize}px; --initial-size: {size}; --initial-cross-size: {crossSize}"
  data-name={name}
>
  <div
    class="header"
    on:click={headerClicked}
    on:keypress={headerClicked}
    role="button"
    tabindex="0"
    bind:this={headerSlotElem}
  >
    <slot name="header">NO HEADER</slot>
    <div class="indicator" bind:this={indicatorElem}>
      <span class="glyph-chevron-left" />
    </div>
  </div>
  <div class="content" bind:this={contentSlotElem}>
    <slot name="content">NO CONTENT</slot>
  </div>
</div>

<style>
  div.fold-container {
    --border-radius: 0.5rem;
  }
  div.fold-container {
    overflow: hidden;
    border-radius: var(--border-radius);
    border: 0.125rem solid var(--base-color-outline-primary, #1A1B1F);
  }
   div.fold-container {
    background-color: var(--base-color-bg-default,hsla(227, 8%, 22%, 0.8));
  }
  div.fold-container.open div.header {
    background-color: var(--base-color-bg-default,hsla(227, 8%, 22%, 1));
  }
  div.fold-container.closed div.header {
    background: var(--base-color-bg-default, hsla(227, 9%, 19%, 1)); 
  }

  div.fold-container.vertical {
    height: var(--initial-size);
    width: var(--initial-cross-size);
    min-height: var(--header-size);
  }

  div.fold-container.horizontal {
    width: var(--initial-size);
    height: var(--initial-cross-size);
    min-width: var(--header-size);
  }

  div.fold-container.vertical.closed {
    height: var(--header-size);
    max-height: var(--header-size);
  }
  div.fold-container.horizontal.closed {
    width: var(--header-size);
    max-width: var(--header-size);
  }

  div.fold-container div.header {
    display: flex;
    align-content: center;
    align-items:stretch;
    cursor:pointer;

  }
  div.fold-container div.header > :global(*) {
    flex-grow: 1;
  }
  div.fold-container div.header > div.indicator {
    flex-grow: 0;
    align-self: center;
    margin: 0 1rem;
    font-size: 0.75rem;
  }

  div.fold-container div.content {
    overflow: auto;
    position: relative;
  }

  div.fold-container.vertical div.content {
    width: 100%;
    height: calc(100% - var(--header-size));
  }

  div.fold-container.horizontal div.content {
    height: 100%;
    width: calc(100% - var(--header-size));
    transform: translateX(var(--header-size))
      translateY(calc(-1 * var(--header-size)));
  }

  div.fold-container.horizontal div.header {
    width: var(--initial-cross-size);
    transform-origin: top left;
    transform: translateY(var(--initial-cross-size)) rotate(-90deg);
  }

  div.fold-container.open div.header div.indicator {
    transform: rotate(-90deg);
  }

</style>
